<template>
	<div>
		<el-dialog title="提示" :visible="VersionLowStatus" width="500px" @close="cancel">
			<div class="tip flexJA flexFs" style="align-items: center;">
				<img src="@/assets/images/mid.png">
				<div>
					<div style="font-size: 14px;color: #fff;line-height: 30px;">设备固件版本过低，请立即升级</div>
					<div>当前版本为{{Version}}，部分功能无法使用，请升级到最新固件版本</div>
				</div>
			</div>
			<div class="btns flexJA flexFe">
				<div class="btn flexJA" @click="cancel">取消</div>
				<div class="btn btn-1 flexJA" @click="confirm">立即升级</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { Loading } from 'element-ui';
	import { debounce } from '../../utils/util.js'
	import http from '../../utils/http';
	export default {
		data() {
			return {
				Version: '',
				flag: true
			}
		},
		computed: {
			...mapState({
				config: (state) => state.config,
				loading: (state) => state.loading,
				Upgrade: (state) => state.Upgrade,
				nextUrl: (state) => state.nextUrl,
				VersionLowStatus: (state) => state.VersionLowStatus,
			}),
		},
		mounted() {
			this.getUpdate();
			this.Version = localStorage.getItem('Version');
			this.GetLightDataSV();
		},
		methods: {
			GetLightDataSV() {
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetLightDataSV",null).then(res=>{
					console.log('LenovoHeadset.dll[GetLightDataSV]: ', res)
					if(res.ver && res.ver.indexOf('V255.255.255') == -1 && res.ver.indexOf('V22') == -1) {
						this.Version = res.ver;
						localStorage.setItem('Version', res.ver);
					}else {
						this.GetLightDataSV();
					}
				}).catch(err => {
					this.GetLightDataSV();
					console.error('LenovoHeadset.dll[GetLightDataSV]: ', err)
				});
			},
			confirm() {
				this.flag = false;
				sessionStorage.setItem('VersionLow', 1);
				this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS1', data: true});
				this.$store.commit('setUpgrade', {status: true, progress: 0, dialogStatus: true, type: 1});
				this.$store.commit('gotState', {key: 'VersionLowStatus', data: false});
			},
			cancel() {
				if(this.flag) {
					this.next();
				}
				sessionStorage.setItem('VersionLow', 1);
				this.$store.commit('gotState', {key: 'VersionLowStatus', data: false});
			},
			next: debounce(function() {
				let loading;
				loading = this.$loading({
					lock: true,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 1)',
					customClass: 'custom-background'
				});
				setTimeout(e=>{
					this.$router.push(this.nextUrl);
				}, 400)
				setTimeout(() => {
				  loading.close();
				}, 2000);
			},50),
			async getUpdate(num = 0) {
				try {
					let StorageUpdate = localStorage.getItem('update') ? JSON.parse(localStorage.getItem('update')) : {};
					const update = await http.get('/lot/file/download?filename=update.json');
					console.log(update);
					window.LZPlugin.nativeCall("FileDownloader.dll", "download_file", `${update.url}|D:/Downloads`).then(res=>{
						console.log('FileDownloader.dll[DownloadFileToLocal]: ', res);
						if(res.code == 0) {
							localStorage.setItem('update', JSON.stringify(update))
							this.$store.commit('gotState', {key: 'update', data: update});
						}else {
							if(num < 3) {
								this.getUpdate(num + 1);
							}
						}
					}).catch(err => {
						console.error('FileDownloader.dll[DownloadFileToLocal]: ', err);
					});
				} catch (error) {
					console.error(error);
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
</style>